import React from 'react'
import { Box, Typography } from '@mui/material'
import { CloudOff } from 'lucide-react'
import { usePageTitle } from 'common/hooks/usePageTitle'

export const NoInternetConnectionPage = () => {
  usePageTitle('No Internet Connection')

  return (
    <Box
      sx={{
        margin: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <CloudOff size={70} />
        <Typography variant="h1">Your internet connection is currently unavailable</Typography>
        <Typography variant="h4" color="text.secondary">
          Please make sure you have an active internet connection
        </Typography>
      </Box>
    </Box>
  )
}
export default NoInternetConnectionPage
